module.exports = __webpack_public_path__ + "img/capslock-fill.8409c41b.svg";